import { createColumnHelper } from '@tanstack/react-table'
import { getConsolidateInvoiceDescription } from '../../../../../../utils/getConsolidateInvoiceDescription'
import type { Purchase } from '../../../../../../types'
import { NavLink } from 'react-router-dom'
import { formatCurrency } from '../../../utils/formatCurrency'

export default function purchaseReportTableColumns({
  chosenCompany,
  handleSetConsolidateInvoice,
}: {
  chosenCompany?: string
  handleSetConsolidateInvoice: (value: string) => void
}) {
  const columnHelper = createColumnHelper<Purchase>()
  return [
    columnHelper.accessor('tyear', {
      id: 'period',
      sortingFn: 'alphanumeric',
      header: 'Periode',
      cell: (row) => (
        <NavLink
          onClick={() => {
            handleSetConsolidateInvoice(row.row.original.consolidatedInvoiceAgreement)
          }}
          className="flex w-fit text-interaction hover:underline hover:text-interactionHover"
          to={`/reports/purchase/${row.row.original.tyear}-${row.row.original.tmonth}`}
        >
          {`${row.row.original.tyear} - ${row.row.original.tmonth}` || ''}
        </NavLink>
      ),
    }),
    columnHelper.accessor('consolidatedInvoiceAgreement', {
      id: 'consolidatedInvoiceAgreement',
      enableSorting: false,
      header: 'Samlefakturakode',
      cell: (row) => getConsolidateInvoiceDescription(row.getValue(), chosenCompany) || '',
    }),
    columnHelper.accessor('amountIncVAT', {
      id: 'amountIncVAT',
      sortingFn: 'alphanumeric',
      meta: {
        mobileFooterLabel: 'Sum av beløp',
        alignmentType: 'right',
      },
      header: 'Beløp',
      cell: (row) => formatCurrency(row.getValue()) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('amountIncVAT') as number) || 0), 0)
        return formatCurrency(total)
      },
    }),
  ]
}
